import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { checkCardStatus, getCustomerCardList } from '../store/api/GuaranteeApi';
import { useHistory } from 'react-router-dom'
import Loader from 'react-loader-spinner';
import { Button, Card, Col, FormGroup, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import barCodeImg from "../content/images/barcodeReader.png";
import QRCodeReader from "../Components/QRCode_Reader/QR_Reader";
import { QuestionDiamond } from 'react-bootstrap-icons';

const GuaranteeCardStatus = () => {
    useEffect(() => {
        document.body.classList = "notMain";
    })
    const [scanData, setScanData] = useState({ProductSerial:"", GCardNo:""});
    const [popQrCode, setPopQrCode] = useState({ show: false });
    const isLoading = useSelector(state => state.loading?.isLoading)
    const dispatch = useDispatch();
    const { register, handleSubmit } = useForm();
    const history = useHistory();
    const onSubmit = (data) => {
        dispatch(
            checkCardStatus(data, () => {
                history.push("/GuaranteeStatusResult")
            })
        );
    }
    const getAllCards = () => {
        dispatch(
            getCustomerCardList(() => {
                history.push("/GuaranteeStatusResult")
            })
        );
    }

    return (
        <div className="container-fluid mt-2">
            <br />
            <form onSubmit={handleSubmit(onSubmit)}>
                <Card>
                    <Card.Header className="card-header headerStyle">
                        <FontAwesomeIcon icon={faQuestionCircle} size='lg' />&nbsp;
                        استعلام گارانتی
                    </Card.Header>
                    <Card.Body className="bodyStyle">
                    <Button variant='light' onClick={() => setPopQrCode({ show: true })} style={{ padding: 0 }}>
                            <img src={barCodeImg} />
                        </Button>
                        {popQrCode.show && window.innerWidth <= 414 && <QRCodeReader setProductData={setScanData} setPopupData={setPopQrCode} />}
                        <Row>
                            <FormGroup className="col-md-3">
                                <label>شماره سریال</label>
                                <input type="text" name="SerialNumber" className="form-control" ref={register} onChange={e=> setScanData({...scanData, ProductSerial: e.target.value})} value={scanData.ProductSerial}/>
                            </FormGroup>
                            <FormGroup className="col-md-3">
                                <label>شماره گارانتی</label>
                                <input type="text" name="CardNo" className="form-control" ref={register} onChange={e=> setScanData({...scanData, GCardNo: e.target.value})} value={scanData.GCardNo}/>
                            </FormGroup>
                            <Col md={2} className='mt-1' style={{ display: "flex", flexWrap: "wrap", alignContent: "flex-end", paddingBottom: "2px", maxWidth:"fit-content", paddingLeft:0 }}>
                                {!isLoading ? <Button type="submit" className="group-Btn"><QuestionDiamond size={18}/>&nbsp; استعلام کارت گارانتی</Button> : <span> لطفا کمی صبر کنید <Loader type="BallTriangle" color="red" height={20} width={20} /> </span>}
                            </Col>
                            <Col md={2} className='mt-1' style={{ display: "flex", flexWrap: "wrap", alignContent: "flex-end", paddingBottom: "2px",maxWidth:"fit-content" }}>
                                {!isLoading ? <Button variant='secondary' className="group-Btn" onClick={getAllCards}><QuestionDiamond size={18} />&nbsp;لیست کارتهای من</Button> : <span> لطفا کمی صبر کنید <Loader type="BallTriangle" color="red" height={20} width={20} /> </span>}
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </form>
        </div>

    );
}
export default GuaranteeCardStatus;